import { Bucket, Audience } from './types'

export const FIELD_NAMES = {
  AUDIENCE: 'audience',
  DATE_RANGE: 'dateRange',
}

export const LABEL_IDS = {
  AUDIENCE: 'audienceLabel',
  DATE_RANGE: 'dateRangeLabel',
}

export const LABELS = {
  AUDIENCE: 'Audience',
  DATE_RANGE: 'Date range',
}

// Ensure all keys have names
type AudienceFieldsNames = { [K in Audience]: string }
export const AUDIENCE_FIELD_NAMES: AudienceFieldsNames = {
  student: 'Students',
  parent: 'Parents',
  all: 'Students and Parents',
}

// Ensure all values match keys
type AudienceFieldValues = { [K in Audience]: K }
export const AUDIENCE_FIELD_VALUES: AudienceFieldValues = {
  student: 'student',
  parent: 'parent',
  all: 'all',
}

// Ensure all keys have names
type DateRangeFieldsNames = { [K in Bucket]: string }
export const DATE_RANGE_FIELD_NAMES: DateRangeFieldsNames = {
  '30d': 'Last 30 Days',
  '90d': 'Last 90 Days',
  '1y': 'This Academic Year',
}

export const PREVIOUS_DATE_RANGE_METRIC_DESCRIPTORS = {
  '30d': 'prev. 30 days',
  '90d': 'prev. 90 days',
  '1y': 'prev. academic year',
}

// Ensure all values match keys
type DateRangeFieldValues = { [K in Bucket]: K }
export const DATE_RANGE_FIELD_VALUES: DateRangeFieldValues = {
  '30d': '30d',
  '90d': '90d',
  '1y': '1y',
}

export const METRIC_TITLES = {
  IMPRESSIONS: 'Impressions',
  USERS_REACHED: 'Users Reached',
  TOTAL_ENGAGEMENT_COUNT: 'Total Engagement',
  TOTAL_ENGAGEMENT_RATE: 'Engagement Rate',
  FOLLOW_COUNT: 'Follower Growth',
  FOLLOW_RATE: 'follow rate',
  PROFILE_VISITS_COUNT: 'Profile Visits',
  PROFILE_VISITS_RATE: 'Profile Visit Rate',
  REFERRAL_TRAFFIC_COUNT: 'Referral Traffic',
  REFERRAL_TRAFFIC_RATE: 'Referral Traffic Rate',
}

export const METRIC_TOOLTIPS = {
  IMPRESSIONS:
    'The number of times your School was on screen (e.g. search, profile views, posts, events and programs).',
  USERS_REACHED: 'The number of unique accounts that have seen your school.',
  TOTAL_ENGAGEMENT_COUNT:
    'The number of interactions with your school (e.g. view profile, view content, link click, and compare).',
  TOTAL_ENGAGEMENT_RATE: 'The rate of accounts reached that engage with your school.',
  FOLLOW_COUNT:
    'The net number of unique student accounts that have added your school to their ‘My Colleges’ list in the Following, Applying or Applied states.',
  FOLLOW_RATE: 'The student accounts that added your college to their list relative to the students you reached.',
  PROFILE_VISITS_COUNT: 'The number of times your profile was visited.',
  PROFILE_VISITS_RATE: 'The rate of accounts reached that view your profile.',
  REFERRAL_TRAFFIC_COUNT: 'The number of clicks on any of the links in your profile or content.',
  REFERRAL_TRAFFIC_RATE: 'The rate of engaged accounts that were referred to your website through Scoir.',
}
